/**
 * Single source of values: `authPasswordDefaults.json`.
 *
 * - Frontend / Vite: `@merlot/common/authPasswordDefaults.js`
 * - Backend CommonJS: `require('.../common/authPasswordDefaults.json')`
 *
 * Used by password change/create validators and UI (ProfileSettings, UserForm).
 * Keep in sync with User schema `password` minLength/maxLength.
 */

import data from './authPasswordDefaults.json' assert { type: 'json' };

export const AUTH_PASSWORD_MIN_LENGTH = data.minLength;
export const AUTH_PASSWORD_MAX_LENGTH = data.maxLength;
